import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useErrorBoundary } from 'react-error-boundary'
import { useZendeskChat } from 'src/hooks/zendesk/useZendeskChat'
import { GlobalNotification } from './GlobalNotification/GlobalNotification'
import { GlobalModalWrapper } from './GlobalModalWrapper/GlobalModalWrapper'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { ClickceaseMonitoringModeModal } from './ClickceaseMonitoringModeModal/ClickceaseMonitoringModeModal'
import { useTagIndicationNotification } from '../hooks/useTagIndicationNotification'
import { useMigrationDisplay } from 'Hooks/useMigrationDisplay'
import { MigrationWelcomeModal } from '../Modals/MigrationWelcomeModal/MigrationWelcomeModal'
import { useFrontEndEventTrackingService } from '@clickcease/cc-client-components-lib'
import { useIsFirstLogin } from 'Hooks/useIsFirstLogin'
import { useHideBannersSplit } from 'Hooks/useHideBannersSplit'
import { isExcludedEmail } from 'Utils/excludeTestAccounts'
import { useInitialAppcues } from '../hooks/useInitialAppcues'

export const ProtectedRouteLogic = () => {
  const navigate = useNavigate()
  const { resetBoundary } = useErrorBoundary()
  const { email, isLoggedIn } = useUserStore()
  const { GetTagModal } = useTagIndicationNotification()
  const { setConfig } = useFrontEndEventTrackingService()
  const { isMigratedAccount, isFirstMigrationLogin } = useMigrationDisplay()

  useIsFirstLogin()
  useZendeskChat()
  setConfig({ shouldSendEvents: !isExcludedEmail(email) })
  useInitialAppcues()
  const { shouldHideBanners } = useHideBannersSplit()

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login')
      resetBoundary() // Reset error to hide ErrorPage.tsx
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn])

  return (
    <>
      {!shouldHideBanners && <GlobalNotification />}
      <GlobalModalWrapper />
      {isFirstMigrationLogin && <MigrationWelcomeModal />}
      {isMigratedAccount && <ClickceaseMonitoringModeModal />}
      {GetTagModal && <GetTagModal />}
    </>
  )
}
